import { render, staticRenderFns } from "./CriProcess.vue?vue&type=template&id=5c27a8d6&scoped=true"
import script from "./CriProcess.vue?vue&type=script&lang=js"
export * from "./CriProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c27a8d6",
  null
  
)

export default component.exports